import React from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { NGANHDAOTAO_API } from '../../../../utils/apiUrl';
import { Post, Put } from '../../../../utils/httpProvider';
import { Formik } from 'formik';
import * as Yup from 'yup';

const NganhDaoTaoModal = ({ isOpen, handleClose, data, refetch }) => {
    const isEdit = !!data;
    const addMutation = useMutation((payload) => Post(NGANHDAOTAO_API.CREATE_ITEM, null, payload));
    const updateMutation = useMutation((payload) => Put(NGANHDAOTAO_API.UPDATE_ITEM, data?.id, payload));

    const initialValues = {
        maNganh: data?.maNganh || '',
        tenNganh: data?.tenNganh || '',
        ghiChu: data?.ghiChu || ''
    };

    const validationSchema = Yup.object().shape({
        maNganh: Yup.string().required('Mã ngành đào tạo là bắt buộc'),
        tenNganh: Yup.string().required('Tên ngành đào tạo là bắt buộc')
    });

    const handleSubmit = (values) => {
        const mutation = isEdit ? updateMutation : addMutation;
        mutation.mutate(values, {
            onSuccess: (res) => {
                if (res.id || res.status === 200 || res === true) {
                    toast.success(isEdit ? "Cập nhật ngành đào tạo thành công!" : "Thêm ngành đào tạo thành công!");
                    refetch();
                    handleClose();
                } else {
                    toast.error("Có lỗi xảy ra, vui lòng thử lại.");
                }
            },
            onError: (err) => {
                toast.error(err?.message || "Có lỗi xảy ra.");
            }
        });
    };

    return (
        <Modal show={isOpen} onHide={handleClose} size="lg" backdrop="static" style={{ zIndex: '9999' }}>
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>{isEdit ? 'Chỉnh sửa ngành đào tạo' : 'Thêm ngành đào tạo mới'}</Modal.Title>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ values, errors, touched, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Mã ngành <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="maNganh"
                                            value={values.maNganh}
                                            onChange={handleChange}
                                            isInvalid={touched.maNganh && !!errors.maNganh}
                                            disabled={isEdit}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.maNganh}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Tên ngành đào tạo <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            name="tenNganh"
                                            value={values.tenNganh}
                                            onChange={handleChange}
                                            isInvalid={touched.tenNganh && !!errors.tenNganh}
                                        />
                                        <Form.Control.Feedback type="invalid">{errors.tenNganh}</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="font-weight-bold">Ghi chú</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="ghiChu"
                                            value={values.ghiChu}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>Đóng</Button>
                            <Button variant="primary" type="submit" disabled={addMutation.isLoading || updateMutation.isLoading}>
                                {(addMutation.isLoading || updateMutation.isLoading) ? 'Đang lưu...' : 'Lưu lại'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );
};

export default NganhDaoTaoModal;
